// extracted by mini-css-extract-plugin
export default {"section":"section_section__21SOW"};